import {createStore} from "vuex";
export default createStore({
    state: {
        // 播放时长
        player: null,
        spinning: false, // 页面加载状态
        growthSys_toast: {rewardValue: 0, type: false}, // 成长体系 任务完成头像框 提示开关
        // 支付页面
        discountSelect_isShow: false, // 优惠券下拉框展开
        exchangeSelect_isShow: false, // 兑换券下拉框展开
    },
    mutations: {
        // 播放器对象
        setPlayer(state, param){
            state['player'] = param
        },
        setSpinning(state, param){
            state['spinning'] = param
        },
        setGrowthSys_toast(state, param){
            state['growthSys_toast'] = param
        },
        setDiscountSelect_isShow(state, param){
            state['discountSelect_isShow'] = param
        },
        setExchangeSelect_isShow(state, param){
            state['exchangeSelect_isShow'] = param
        },
    },
    actions: {},
    modules: {},
});
